var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection3Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 9,
    viewBox: "0 0 370 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 356,
    height: 3,
    transform: "matrix(-1 0 0 1 363 3)",
    fill: "#003A75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0C6.98528 0 9 2.01472 9 4.5C9 6.98528 6.98528 9 4.5 9C2.01472 9 0 6.98528 0 4.5C0 2.01472 2.01472 0 4.5 0ZM4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3Z",
    fill: "#003A75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M365.5 0C367.985 0 370 2.01472 370 4.5C370 6.98528 367.985 9 365.5 9C363.015 9 361 6.98528 361 4.5C361 2.01472 363.015 0 365.5 0ZM365.5 3C364.672 3 364 3.67157 364 4.5C364 5.32843 364.672 6 365.5 6C366.328 6 367 5.32843 367 4.5C367 3.67157 366.328 3 365.5 3Z",
    fill: "#003A75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection3Line);
export default __webpack_public_path__ + "static/media/section3_line.ab76c8d1479d0f64e4aba6d85d64f94a.svg";
export { ForwardRef as ReactComponent };